const Footer = () => {
    return (

        <div>
            <p className="copyright" style={{ color: 'black', width: '100%', textAlign: 'center', padding: '20px', marginTop: '20px', opacity: 0.8 }}>&copy;2021 - <a href="https://github.com/philipHinch" target="_blank" style={{ color: 'black' }}>https://github.com/philipHinch</a></p>
        </div>

    );
}

export default Footer;